import React, { FC, useEffect } from 'react';
import { IRunningActivities } from '../../interface/RunningActivities.interface';
import { useCountdown } from '../../../../core/hooks/useCount';
import { Link } from 'react-router-dom';
import { BsArrowRight } from 'react-icons/bs';

interface ActivitiesProps {
	activity: IRunningActivities;
	refetch;
}

const Activities: FC<ActivitiesProps> = ({ activity, refetch }) => {
	const time = useCountdown(activity.targetTime);
	useEffect(() => {
		if (time === '00 : 00 : 00 : 01') {
			refetch();
		}
		return () => {};
	}, [time]);
	return (
		<>
			<div className="running__activity__container text__default flex flex-col justify-start border-b last:border-none">
				<div className="running__Activity__header flex items-center gap-3">
					<img className="h-16 w-16 rounded-full" src={activity.image} alt={activity.name} />
					<div className="flex flex-col items-start">
						<div className="running__Activity__name font-manropeBold text-lg text-[##404040]">{activity.name}</div>
						<div className="rounded-full bg-[#0D4B4C1A] px-8 py-1 text-center text-[#0D4B4C]">{activity.type}</div>
					</div>
				</div>
				<p className="text__default running__activity__des text-[##808080]">{activity.description}</p>
				<div className="running__Activity__tail flex items-center justify-between">
					<div className="running__Activity__tail">
						<span className=" text-[#808080]">Count down : </span>
						<span className="text-[#01ABC1]">{time}</span>
					</div>
					<Link to={activity.slug}>
						<button className="flex flex-row items-center gap-2 rounded-full bg-[#01ABC11A] px-2.5 py-2.5 text-[#01ABC1]">
							<BsArrowRight />
						</button>
					</Link>
				</div>
			</div>
		</>
	);
};

export default Activities;
